export const translations = {
  es: {
    nav: {
      gallery: 'Galería',
      collections: 'Colecciones',
      writings: 'Literatura',
      about: 'Artista',
      acquire: 'Adquirir'
    },
    hero: {
      location: 'Barcelona',
      virtualGallery: 'Galería Virtual',
      subheader: 'ARTISTA MULTIDISCIPLINAR',
      description: 'Obra pictórica de Francesc Chimelis. Innovación y creatividad en un estilo personal único que fusiona lo real con lo imaginario.',
      seoTitle: 'CHIMELISART | Artista Multidisciplinar',
      seoDescription: 'Explora la obra pictórica y literaria de Francesc Chimelis. Artista multidisciplinar, arte contemporáneo y narrativa inmersiva desde Barcelona.'
    },
    gallery: {
      title: 'Obra',
      subtitle: 'Seleccionada',
      swipe: 'Desliza para descubrir',
      filters: {
        all: 'Todas',
        available: 'Disponible',
        sold: 'Vendida',
        reserved: 'Reservada'
      }
    },
    features: {
      title: 'Francesc',
      subtitle: 'CHIMELIS',
      description: 'Artista polifacético nacido en Barcelona (1956). Su trayectoria abarca cuatro décadas de innovación como artista multidisciplinar, además de una destacada carrera en las artes escénicas y la literatura.',
      items: [
        { title: 'Técnica Mixta', desc: 'Exploración matérica sobre lienzo con un lenguaje visual propio.' },
        { title: 'Trayectoria', desc: 'Más de 26 exposiciones individuales y colectivas en centros de prestigio.' },
        { title: 'Multidisciplinar', desc: 'Pintor, actor, director de teatro y novelista; una visión integral del arte.' }
      ]
    },
    acquisition: {
      title: 'CONTACTO',
      subtitle: 'Interés en Obra Original',
      tiers: [
        { name: 'Catálogo', price: 'PDF', subtitle: 'Información Detallada', features: ['Especificaciones técnicas', 'Precios actuales'] },
        { name: 'Obra Original', price: 'Consulta', subtitle: 'Piezas Disponibles', features: ['Certificado de Autenticidad', 'Gestión de envío', 'Visita al estudio'] },
        { name: 'Encargos', price: 'Personal', subtitle: 'Proyectos a Medida', features: ['Consulta directa', 'Estudio previo', 'Seguimiento del proceso'] }
      ],
      cta: {
        add: 'Solicitar Info',
        adding: 'Enviando...',
        another: 'Solicitar Más'
      }
    },
    cart: {
      title: 'Tu Selección',
      empty: 'No has seleccionado ninguna obra',
      viewOptions: 'Ver Galería Principal',
      subtotal: 'Presupuesto estimado',
      consult: 'Consultar',
      checkout: 'Proceder al Pago',
      note: 'Los detalles de envío y disponibilidad se confirmarán vía email.'
    },
    modal: {
      year: 'Año',
      consult: 'Consultar Pieza',
      related: 'Otras Obras',
      sold: 'Obra Vendida',
      reserved: 'Obra Reservada',
      purchaseOptions: 'Opciones de Compra',
      original: {
        title: 'Obra Original',
        desc: 'Pieza única, firmada por el artista',
        inquire: 'Consultar'
      },
      print: {
        title: 'Impresión Fine Art (A2)',
        desc: 'Papel de archivo calidad museo'
      },
      digital: {
        title: 'Licencia Digital',
        desc: 'Alta resolución para uso personal'
      },
      cta: {
        inquire: 'Consultar',
        add: 'Añadir al Carrito'
      }
    },
    cursor: 'Ver'
  },
  en: {
    nav: {
      gallery: 'Gallery',
      collections: 'Collections',
      writings: 'Literature',
      about: 'About',
      acquire: 'Inquire'
    },
    hero: {
      location: 'Barcelona',
      virtualGallery: 'Virtual Gallery',
      subheader: 'MULTIDISCIPLINARY ARTIST',
      description: 'Pictorial work by Francesc Chimelis. Innovation and creativity in a unique personal style that merges the real with the imaginary.',
      seoTitle: 'CHIMELISART | Multidisciplinary Artist',
      seoDescription: 'Explore the pictorial and literary work of Francesc Chimelis. Multidisciplinary artist, contemporary art, and immersive narrative from Barcelona.'
    },
    gallery: {
      title: 'Selected',
      subtitle: 'Works',
      swipe: 'Swipe to discover',
      filters: {
        all: 'All',
        available: 'Available',
        sold: 'Sold',
        reserved: 'Reserved'
      }
    },
    features: {
      title: 'Francesc',
      subtitle: 'CHIMELIS',
      description: 'Multifaceted artist born in Barcelona (1956). His career spans four decades of innovation as a multidisciplinary artist, alongside a notable career in performing arts and literature.',
      items: [
        { title: 'Mixed Media', desc: 'Material exploration on canvas with a unique visual language.' },
        { title: 'Career', desc: 'Over 26 solo and group exhibitions in prestigious art centers.' },
        { title: 'Multidisciplinary', desc: 'Painter, actor, theater director, and novelist; a holistic vision of art.' }
      ]
    },
    acquisition: {
      title: 'CONTACT',
      subtitle: 'Interest in Original Art',
      tiers: [
        { name: 'Catalog', price: 'PDF', subtitle: 'Detailed Information', features: ['Technical specs', 'Current pricing'] },
        { name: 'Original Work', price: 'Inquire', subtitle: 'Available Pieces', features: ['Certificate of Authenticity', 'Shipping management', 'Studio visit'] },
        { name: 'Commissions', price: 'Custom', subtitle: 'Tailored Projects', features: ['Direct consultation', 'Preliminary study', 'Process tracking'] }
      ],
      cta: {
        add: 'Request Info',
        adding: 'Sending...',
        another: 'Request More'
      }
    },
    cart: {
      title: 'Your Selection',
      empty: 'No items selected',
      viewOptions: 'Browse Gallery',
      subtotal: 'Estimated Budget',
      consult: 'Consult',
      checkout: 'Proceed to Payment',
      note: 'Shipping and availability details will be confirmed via email.'
    },
    modal: {
      year: 'Year',
      consult: 'Inquire Piece',
      related: 'Related Works',
      sold: 'Sold Out',
      reserved: 'Reserved',
      purchaseOptions: 'Purchase Options',
      original: {
        title: 'Original Artwork',
        desc: 'One of a kind, signed by artist',
        inquire: 'Inquire'
      },
      print: {
        title: 'Fine Art Print (A2)',
        desc: 'Museum quality archival paper'
      },
      digital: {
        title: 'Digital License',
        desc: 'High-res for personal use'
      },
      cta: {
        inquire: 'Inquire',
        add: 'Add to Cart'
      }
    },
    cursor: 'View'
  }
};
